import { defineComponent as _defineComponent } from 'vue'
import { SContactUs } from '@slg/web-customer-shared';
import { useStore } from '@/composables';


const __default__ = {
  name: 'ContactUsPage',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

function setGlobalLoading(loadingState: boolean) {
  store.commit('common/setGlobalLoading', loadingState);
}

return { __sfc: true,store, setGlobalLoading, SContactUs }
}

})